// ── IndexedDB pagalbininkas PDF saugojimui ──
const TAKEOFF_DB = (() => {
  const DB_NAME = 'sannamai_takeoff';
  const STORE = 'pdfs';
  function openDb() {
    return new Promise((res, rej) => {
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = e => e.target.result.createObjectStore(STORE);
      req.onsuccess = e => res(e.target.result);
      req.onerror = e => rej(e.target.error);
    });
  }
  return {
    save: async (id, buf) => {
      const db = await openDb();
      return new Promise((res, rej) => {
        const tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).put(buf, id);
        tx.oncomplete = res; tx.onerror = e => rej(e.target.error);
      });
    },
    load: async (id) => {
      const db = await openDb();
      return new Promise((res, rej) => {
        const tx = db.transaction(STORE, 'readonly');
        const req = tx.objectStore(STORE).get(id);
        req.onsuccess = e => res(e.target.result);
        req.onerror = e => rej(e.target.error);
      });
    },
    delete: async (id) => {
      const db = await openDb();
      return new Promise((res, rej) => {
        const tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).delete(id);
        tx.oncomplete = res; tx.onerror = e => rej(e.target.error);
      });
    },
  };
})();

export { TAKEOFF_DB };
